import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    removeButton: {
        cursor: 'pointer',
        transition: 'all 0.1s ease',
        display: 'inline-block',
        borderRadius: '50%',
        transform: 'rotate(45deg)',
        '&:hover': {
            transform: 'scale(1.15) rotate(45deg)',
        }
    },
    bright: {
        '&:hover': {
            '& circle': {
                fill: '#FFFFFF !important',
            }
        }
    },
    dark: {
        '&:hover': {
            '& circle': {
                fill: '#E8E8E8 !important',
            }
        }
    }
}));

interface RemoveButtonProps {
    onClick: (e: React.MouseEvent) => void;
    size?: number;
    variant?: 'bright' | 'dark';
    style?: React.CSSProperties;
    className?: string;
}

const RemoveButton: React.FC<RemoveButtonProps> = ({
    onClick,
    size = 14,
    variant = 'bright',
    style,
    className = ''
}) => {
    const classes = useStyles();

    const circleColor = variant === 'bright' ? '#FFFFFFDD' : '#F5F5F5';
    const rectColor = variant === 'bright' ? '#828282' : 'white';

    return (
        <svg
            className={`${classes.removeButton} ${classes[variant]} ${className}`}
            width={size}
            height={size}
            viewBox="0 0 48 48"
            onClick={onClick}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <circle cx="24" cy="24" r="24" fill={circleColor} />
            <rect x="8" y="21" width="33" height="6" rx="3" fill={rectColor} />
            <rect x="27" y="7" width="33" height="6" rx="3" transform="rotate(90 27 7)" fill={rectColor} />
        </svg>
    );
};

export default RemoveButton;
